import styled from 'styled-components';

import { whiteSphera, blackSphera, greenSp } from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalCodeSuccess = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalCodeSuccess ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalCodeSuccess ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;

  > div {
    width: 40%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 2.5%;

    > div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding-bottom: 2.5%;
      border-bottom: 1px solid #b7bcc7;

      > h3 {
        font-size: 1.5vw;
        color: ${blackSphera};
        width: 90%;
        padding-left: 5%;
      }

      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > div:nth-child(1) {
        > h3 {
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;

      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;

        > h3 {
          font-size: 4.5vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const ChangePassword = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5% 5% 0 2.5%;

  > p:nth-child(1) {
    font-size: 1.2vw;
    text-align: center;
    color: ${blackSphera};
    margin-bottom: 5%;

    > span {
      color: ${greenSp};
      font-weight: bold;
    }
  }

  > button:nth-child(2) {
    color: ${whiteSphera};
    font-size: 1.2vw;
    font-weight: bold;
    text-align: center;
    width: 40%;
    height: 50px;
    margin: auto;
    border: none;
    border-radius: 5px;
    background-color: ${blackSphera};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p:nth-child(1) {
      > span {
      }
    }

    > button:nth-child(2) {
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;

    > p:nth-child(1) {
      font-size: 4.2vw;
      width: 95%;

      > span {
      }
    }

    > button:nth-child(2) {
      font-size: 4.2vw;
      width: 95%;
      height: 50px;
      margin: 0;
    }
  }
`;
